<div class="search-grid">
  <div class="inpp">
  <label class="search-label" for="search">Search by</label>
  <select name="filterdropdown" class="groupdropdown drpdown" *ngIf="findOptions.length > 0" [(ngModel)]="searchField">
    <ng-container *ngFor="let item of findOptions">
      <option [ngValue]="item">{{ item.label }}</option>
    </ng-container>
  </select>

  <input
    [(ngModel)]="searchValue"
    type="text"
    class="search-box"
    [ngClass]="{
      'search-boxwidth35': !showDateRange,
      'search-boxwidth15': showDateRange,
    }"
    (keyup.enter)="applyFilterByField()"
  />
  <button class="search-btn" (click)="applyFilterByField()">
    <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
  </button>
  <span class="link-btn p-2" (click)="clearSearchBox()">Clear Search</span>
  <span class="link-btn p-2" (click)="clearFilter()">Clear Filter</span>
  <span *ngIf="showDateRange">
    <span class="date-range">Select Range:</span>
    <input
      class="fromdate"
      [ngModel]="fromDate | date: 'yyyy-MM-dd'"
      (ngModelChange)="fromDate = $event"
      type="date"
      name="fromDate"
      (change)="applySelectedDateRange()"
    />

    <input
      class="todate"
      [ngModel]="toDate | date: 'yyyy-MM-dd'"
      (ngModelChange)="toDate = $event"
      type="date"
      name="toDate"
      (change)="applySelectedDateRange()"
    />

    <input type="button" class="reset-btn link-btn" value="Reset" (click)="resetDateRange()" />
  </span>
  </div>

  <div *ngIf="showHideHeaderColumnCount" class="column-hide" (click)="showHideColumns()">
    <img
      alt=""
      src="{{ baseHref }}/assets/images/icon-tab-eye.png"
      style="width: 1rem; height: 1rem; margin-top: -0.25rem"
    />
    <span class="hid-col">Show Hide Columns ({{ headercount.shown }}/{{ headercount.hidden }})</span>
  </div>
</div>
